import React from 'react';

const OrganizationFilter = ({ organizations, selectedOrg, onOrgChange, theme = {}, showStarredOnly = false, onStarredChange }) => {
  // Default theme values if not provided
  const defaultTheme = {
    text: 'text-gray-900',
    secondaryText: 'text-gray-600',
    background: 'bg-white',
    border: 'border-gray-300'
  };

  // Merge provided theme with defaults
  const currentTheme = { ...defaultTheme, ...theme };

  return (
    <div className="flex flex-row gap-4 items-center flex-end">
      <div className="w-1/5 text-left">
        <label htmlFor="organization-filter" className={`block text-sm font-medium ${currentTheme.secondaryText} mb-1`}>
          Filter by Organization:
        </label>
      </div>
      <div className="w-full col-span-1 text-left">
      <select
        id="organization-filter"
        value={selectedOrg}
        onChange={(e) => onOrgChange(e.target.value)}
        className={`block w-full rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm p-2 border ${currentTheme.background} ${currentTheme.text} ${currentTheme.border}`}
        disabled={organizations.length === 0}
        aria-label="Filter events by organization"
      >
        <option value="all">All Organizations</option>
        {organizations.map(org => (
          <option key={org} value={org}>{org}</option>
        ))}
      </select>
      </div>
      <div className="w-20 text-left">
      {selectedOrg !== 'all' && (
        <button 
          onClick={() => onOrgChange('all')}
          className="py-2 px-4 rounded-lg transition flex items-center"
        aria-label="Toggle filters"
      >
        <i className="fas fa-trash" aria-hidden="true" aria-label="Toggle filters"></i>
      </button>  
      )}
      </div>
      <div className="flex items-center ml-2">
        <input
          id="starred-filter"
          type="checkbox"
          checked={showStarredOnly}
          onChange={e => onStarredChange && onStarredChange(e.target.checked)}
          className="form-checkbox h-5 w-5 text-yellow-500 border-gray-300 focus:ring-yellow-400"
        />
        <label htmlFor="starred-filter" className={`ml-2 text-sm font-medium ${currentTheme.secondaryText} flex items-center`}>
          <i className="fas fa-heart text-red-500 mr-1"></i> Favorites Only
        </label>
      </div>
    </div>
  );
};

export default OrganizationFilter; 